const dateTimeFormats = {
    en: {
        time: { hour: 'numeric', minute: 'numeric', second: 'numeric' },
        short: { year: "numeric", month: "numeric", day: "numeric", hour: 'numeric', minute: 'numeric' }
    }
}
export default dateTimeFormats